import {
    addBrToLiWhichContainsParagraph,
    removeLineBreaksInList,
    removeLineBreaksInTable,
} from '@src/Application/Utils/StringUtility'
import {
    ARTICLE_SECTION_HEADING_REGEXP,
    ARTICLE_SECTION_SUBMENU_REGEXP,
    STRIP_HTML_TAGS,
} from '@src/Core/Constants/PageConstants'
import { getDOMIdFromString } from '@src/Infrastructure/Url/getDomIdFromString'

// inject achor links for headings(h2/h3) and remove line breaks in table
export const parseHtml = (input: string): string => {
    const removedBrFromTable = removeLineBreaksInTable(input)

    //TODO : remove after strapi upgrade to 4
    const removedBrFromUL = removeLineBreaksInList(removedBrFromTable)
    //TODO : remove after strapi upgrade to 4
    const html = addBrToLiWhichContainsParagraph(removedBrFromUL)

    const headings = html.match(ARTICLE_SECTION_HEADING_REGEXP) ?? []
    const subHeadings = html.match(ARTICLE_SECTION_SUBMENU_REGEXP) ?? []
    const contentGuideAnchors = [...headings, ...subHeadings].map((page) => page.replace(STRIP_HTML_TAGS, ''))

    return contentGuideAnchors.reduce(
        (content, anchor) => content.replace(anchor, `<a id="${getDOMIdFromString(anchor)}"></a>${anchor}`),
        html
    )
}
